
import {gql, useQuery} from '@apollo/client';

import {DexaMetric} from './types';

export interface Vars {
	cache: string
}

export interface Summary {
	start: {
		full: string
	}
	fat: number
	lean: number
	bone: number
}

export interface Section {
	metric: DexaMetric
	results: {
		start: {
			date: string
			full: string
			short: string
			time: string
		}
		age: number
		value: number
		parse: string
		percentile: number
	}[]
	snapshots: {
		binMin: number
		binMax: number
		population: number
	}[]
	historicals: {
		age: number
		breakpoints: number[]
	}[]
}

export interface Dexa {
	id: string
	error?: string

	inputsJson: string
	summary: Summary[]
	sections: Section[]
	images?: string[]

	created?: {unix: string}
	owner: boolean
	reference?: number
}

export interface Result {
	reports: {
		dexa: Dexa
	}
}

const getCache = gql`
query ($cache: ID!) {
    reports {
		id
		dexa(cache: $cache) {
			id
			error

			inputsJson

			summary {
				start {
					full: time(fmt: "Jan 02, 2006 at 3:04pm")
				}
				fat: fatGrams
				lean: leanGrams
				bone: boneGrams
			}

			sections {
				metric
				results {
					start {
						date
						full: time(fmt: "Jan 02, 2006 at 3:04pm")
						short: time(fmt: "01/02/06")
						time(fmt: "03:04pm MST")
					}
					age
					value
					parse: string
					percentile
				}
				snapshots {
					binMin
					binMax
					population
				}
				historicals {
					age
					breakpoints
				}
			}

			images

			created { unix }
			owner
			reference
		}
    }
}`;

export const useCache = (vars: Vars) => {
	const {data, ...rest} = useQuery<Result, Vars>(getCache, {
		variables: {...vars},
	});

	return {
		data,
		...rest,
		valid: Boolean(
			(data?.reports?.dexa) &&
			!data.reports.dexa.error
		),
	};
};
